import { clone } from 'lodash'

export const getterTypes = {
	pages: 'pages',
	pagesFind: 'pagesFind',
	pagesParents: 'pagesParents',
	pagesSkeleton: 'pagesSkeleton',	
	pagesFilesAll: 'pagesFilesAll',
	pagesFilesFind: 'pagesFilesFind',
	pagesSnippetsAll: 'pagesSnippetsAll',
	pagesSnippetsFind: 'pagesSnippetsFind',
	pagesSnippetsFindSlug: 'pagesSnippetsFindSlug',
	pagesSnippetsSkeleton: 'pagesSnippetsSkeleton',	
	pagesValidationErrors: 'pagesValidationErrors',
	pagesValidationMessage: 'pagesValidationMessage',
	pagesValidationModal: 'pagesValidationModal',
};

export default {
	[getterTypes.pages]: state => state.pages,
	[getterTypes.pagesFind]: state => id => state.pages.find(temp => temp.id == id),	
	[getterTypes.pagesParents]: state => state.pages, //state.pages.filter(temp => temp.parentId > 0),	
	[getterTypes.pagesSkeleton]: state => clone(state.pagesSkeleton),
	[getterTypes.pagesFilesAll]: state => state.pagesFiles,
	[getterTypes.pagesFilesFind]: state => pageId => state.pagesFiles.filter(temp => temp.pageId == parseInt(pageId)).sort((a,b) => a.position > b.position),
	[getterTypes.pagesSnippetsAll]: state => state.pagesSnippets,
	[getterTypes.pagesSnippetsFind]: state => id => state.pagesSnippets.find(temp => temp.id == id),
	[getterTypes.pagesSnippetsFindSlug]: state => slug => state.pagesSnippets.find(temp => temp.slug == slug),
	[getterTypes.pagesSnippetsSkeleton]: state => clone(state.pagesSnippetSkeleton),        
	[getterTypes.pagesValidationModal]: state => state.pagesValidationModal,
	[getterTypes.pagesValidationErrors]: state => state.pagesValidationErrors,
	[getterTypes.pagesValidationMessage]: state => prop => {
		const temp = state.pagesValidationErrors[prop]
		return Array.isArray(temp)
			? temp[0]
			: temp
	},
};